import { PhotoshopController } from '../../../../photoshopController.js';
import { ParametersWidget } from './parameterWidget.js';
import * as noUiSlider from '../../../../../node_modules/nouislider';
declare global {
    interface HTMLElement {
        noUiSlider?: noUiSlider.API;
    }
}
export class HueSaturationParameterWidget extends ParametersWidget {

    constructor(parent: HTMLElement, controller: PhotoshopController, operation: any) {
        super(parent, controller);
        this.operation = operation;
        this.parent.innerHTML = HueSaturationParameterWidget.html();
        super.initEvent();

        this.updateModel();
        this.initializeHueSaturationRange();
    }

    static html() {
        return super.header() + '\
        <div id="hueSaturation" style="display: none; padding: 10px;">\
            <h4 class="center-align">Teinte/Saturation</h4>\
            <div class="col s12 divider"></div>\
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">\
                <div class="col s10 no-padding">Teinte</div>\
                <div class="col s2 no-padding">\
                    <input id="hs-hue-input" type="number">\
                </div>\
            </div>\
            <div class="col s12 no-padding">\
                <div id="hs-hue-range" class="col s12 row"></div>\
            </div>\
            <div class="col s12 divider"></div>\
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">\
                <div class="col s10 no-padding">Saturation</div>\
                <div class="col s2 no-padding">\
                    <input id="hs-saturation-input" type="number">\
                </div>\
            </div>\
            <div class="col s12 no-padding">\
                <div id="hs-saturation-range" class="col s12 row"></div>\
            </div>\
            <div class="col s12 divider"></div>\
            <div class="col s12 no-padding row no-margin" style="margin-top: 10px;">\
                <div class="col s10 no-padding">Luminosité</div>\
                <div class="col s2 no-padding">\
                    <input id="hs-luminosity-input" type="number">\
                </div>\
            </div>\
            <div class="col s12 no-padding">\
                <div id="hs-luminosity-range" class="col s12 row"></div>\
            </div>\
        </div>\
        '+ super.footer();
    }

    hs_hue_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.hue = value;
        this.photoshopController.update();
    }

    hs_saturation_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.saturation = value;
        this.photoshopController.update();
    }

    hs_luminosity_inputOnChange(value) {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.luminosity = value;
        this.photoshopController.update();
    }

    updateModel() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation) {
            if (this.photoshopController.PSEngine.activeOperation.hue !== undefined) {
                const hueInput = document.getElementById("hs-hue-input") as HTMLInputElement | null;
                if (hueInput) {
                    hueInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.hue;
                    hueInput.min = this.photoshopController.PSEngine.activeOperation.minHue;
                    hueInput.max = this.photoshopController.PSEngine.activeOperation.maxHue;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.saturation !== undefined) {
                const saturationInput = document.getElementById("hs-saturation-input") as HTMLInputElement | null;
                if (saturationInput) {
                    saturationInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.saturation;
                    saturationInput.min = this.photoshopController.PSEngine.activeOperation.minSaturation;
                    saturationInput.max = this.photoshopController.PSEngine.activeOperation.maxSaturation;
                }
            }
            if (this.photoshopController.PSEngine.activeOperation.luminosity !== undefined) {
                const luminosityInput = document.getElementById("hs-luminosity-input") as HTMLInputElement | null;
                if (luminosityInput) {
                    luminosityInput.valueAsNumber = this.photoshopController.PSEngine.activeOperation.luminosity;
                    luminosityInput.min = this.photoshopController.PSEngine.activeOperation.minLuminosity;
                    luminosityInput.max = this.photoshopController.PSEngine.activeOperation.maxLuminosity;
                }
            }
        }
    }

    updateIf() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        super.updateIf();
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.program === 'hueSaturation') {
            const hueSaturationElem = document.getElementById("hueSaturation");
            if (hueSaturationElem) {
                hueSaturationElem.style.display = "";
            }
        } else {
            const hueSaturationElem = document.getElementById("hueSaturation");
            if (hueSaturationElem) {
                hueSaturationElem.style.display = "none";
            }
        }
    }

    initializeHueSaturationRange() {
        window.setTimeout(() => {
            if (!this.photoshopController.PSEngine) {
            return;
        }
            var hueRange = document.getElementById("hs-hue-range");
            if (hueRange) {
                if (hueRange.noUiSlider) {
                    hueRange.noUiSlider.destroy();
                }
                noUiSlider.create(hueRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.hue],
                    step: 1,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minHue,
                        max: this.photoshopController.PSEngine.activeOperation.maxHue
                    }
                });
                if (hueRange.noUiSlider) {
                    hueRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.hue = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const hueInputElem = document.getElementById('hs-hue-input') as HTMLInputElement | null;
                if (hueInputElem) {
                    hueInputElem.addEventListener('change', function (event) {
                        this.hs_hue_inputOnChange(event.currentTarget.valueAsNumber);
                        if (hueRange && hueRange.noUiSlider) {
                            hueRange.noUiSlider.set([event.currentTarget.value]);
                        }
                    }.bind(this));
                }
            }

            var saturationRange = document.getElementById("hs-saturation-range");
            if (saturationRange) {
                if (saturationRange.noUiSlider) {
                    saturationRange.noUiSlider.destroy();
                }
                noUiSlider.create(saturationRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.saturation],
                    step: 1,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minSaturation,
                        max: this.photoshopController.PSEngine.activeOperation.maxSaturation
                    }
                });
                if (saturationRange.noUiSlider) {
                    saturationRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.saturation = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const saturationInputElem = document.getElementById('hs-saturation-input') as HTMLInputElement | null;
                if (saturationInputElem) {
                    saturationInputElem.addEventListener('change', function (event) {
                        this.hs_saturation_inputOnChange(event.currentTarget.valueAsNumber);
                        if (saturationRange && saturationRange.noUiSlider) {
                            saturationRange.noUiSlider.set([event.currentTarget.value]);
                        }
                    }.bind(this));
                }
            }

            var luminosityRange = document.getElementById("hs-luminosity-range");
            if (luminosityRange) {
                if (luminosityRange.noUiSlider) {
                    luminosityRange.noUiSlider.destroy();
                }
                noUiSlider.create(luminosityRange, {
                    start: [this.photoshopController.PSEngine.activeOperation.luminosity],
                    step: 1,
                    range: {
                        min: this.photoshopController.PSEngine.activeOperation.minLuminosity,
                        max: this.photoshopController.PSEngine.activeOperation.maxLuminosity
                    }
                });
                if (luminosityRange.noUiSlider) {
                    luminosityRange.noUiSlider.on('update', function (values, handle) {
                        this.photoshopController.PSEngine.activeOperation.luminosity = Number(values[0]);
                        this.updateModel();
                        this.photoshopController.update();
                    }.bind(this));
                }
                const luminosityInputElem = document.getElementById('hs-luminosity-input') as HTMLInputElement | null;
                if (luminosityInputElem) {
                    luminosityInputElem.addEventListener('change', function (event) {
                        this.hs_luminosity_inputOnChange(event.currentTarget.valueAsNumber);
                        if (luminosityRange && luminosityRange.noUiSlider) {
                            luminosityRange.noUiSlider.set([event.currentTarget.value]);
                        }
                    }.bind(this));
                }
            }
        });
    }

    reglages_undoOnClick() {
        super.reglages_undoOnClick();
        this.updateModel();
        this.updateIf();
        this.initializeHueSaturationRange();
    }
}